import { useAuth } from "../../../contexts/AuthContext";
import '../../../Styles/Layout/Items/PremiumTag.css';


export const PremiumTag = () => {
    const { isUltimate } = useAuth();

    if(isUltimate) return null;

    return (
        <span className='premium-tag'>
            Ultimate
        </span>
    )
}